import { render } from "./PayPalTab.vue?vue&type=template&id=048a3323"
import script from "./PayPalTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPalTab.vue?vue&type=script&setup=true&lang=js"

import "./PayPalTab.vue?vue&type=style&index=0&id=048a3323&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/modules/billing/components/braintree/PayPalTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "048a3323"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('048a3323', __exports__)) {
    console.log('reload')
    api.reload('048a3323', __exports__)
  }
  
  module.hot.accept("./PayPalTab.vue?vue&type=template&id=048a3323", () => {
    console.log('re-render')
    api.rerender('048a3323', render)
  })

}


export default __exports__